import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Like from '../../assets/icone/header/iconFavoriteOut.svg';
import LikeFill from '../../assets/icone/header/iconaPreferitiFill.svg';

const LikeButton = ({ onClick }) => {
  // Usare il hook useLocation per ottenere la route corrente
  const location = useLocation();

  // Verifica se la route contiene "/favorite"
  const isFavoritePage = location.pathname.includes('/favorite');

  return (
    <Link to="/favorite" onClick={onClick}>
      <img 
        src={isFavoritePage ? LikeFill : Like} 
        alt="Preferite icon" 
        className="lg:w-6 md:w-4" 
      />
    </Link>
  );
}

export default LikeButton;
